/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {obtenerPlaca} from "../../Utilidades/obtenerPlaca";
import Formulario_Check_Conductor from "../../Checks/Formularios/Formulario_Check_Conductor";
import Formulario_Check_Moto from "../../Checks/Formularios/Formulario_Check_Moto";

const Dialogo_Lista_Checks = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()
        entidad.placa = obtenerPlaca(entidad.placa)
        entidad.fecha = new Date().getTime()
        entidad.tipo = 'Moto'
        entidad.idConductor = entidad.id
        delete entidad.id

        iniciarCarga()
        let dox = await guardarDoc('listascheckeo', entidad)
        if (dox.res) {
            terminar({aviso: 'Datos correctamente entregados'})

        } else {
            terminar({aviso: 'No se subio el formulario, intentelo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('listascheckeo', datos.id)
        terminar({aviso: 'Conductor borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={6}>
                <Typography>Datos del conductor</Typography>
            </Grid>

            <Grid container size={12} sx={{mt: 2}}>
                <Formulario_Check_Conductor props={props}/>
            </Grid>

            <Grid container size={12} sx={{mt: 4}}>
                <Formulario_Check_Moto props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Actualizar</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Lista_Checks